import { h, Component } from "preact";
import { getTimeInAdaptiveFormat } from "../helpers/dateHelpers";

class AdaptativeDate extends Component {
    constructor() {
        super();
        this.state = { adaptativeDate: "" };
    }

    componentDidMount() {
        getTimeInAdaptiveFormat(
            Date.parse(this.props.currentDate),
            this.props.dateNow,
            this.props.culture
        )
            .then((date) => {
                this.setState({ adaptativeDate: date });
            })
            .catch(() => this.setState({ adaptativeDate: "" }));
    }

    render({}, { adaptativeDate }) {
        return <span>{adaptativeDate}</span>;
    }
}
export default AdaptativeDate;
